/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {recoveryLogin} from '../api'

export const useMutationRecoveryLogin = createReactQueryMutationHook('recoveryLogin', recoveryLogin)
